import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BackgroundOverlay } from "../FilterComp/index.styled";
import Info from "../Info";
import { ReactComponent as CompareCrossSolid } from "../../Assets/Icons/CompareCrossSolid.svg";
import { ReactComponent as NewSortModel } from "../../Assets/Icons/NewSortModel.svg";
import { ReactComponent as NoKPIsSelectedIcon } from "../../Assets/Icons/NoKPIsSelectedIcon.svg";
import { ReactComponent as DeleteWeightage } from "../../Assets/Icons/DeleteWeightage.svg";
import { ReactComponent as Arrow } from "../../Assets/Icons/Arrow.svg";
import { viewSizeCalculator } from "../../utils";
import styled from "styled-components";
import CustomInput from "../Input";
import { stateList } from "../../Assets/MockData";
import { data, hospitalsList } from "./MockData";
import { states } from "../../Configs/config";
import HospitalListCard from "../HospitalList/HospitalListCard";
import WeightageInput from "./WeightageInput";
import { 
  sliderToPercentageWeightages, 
  percentageToSliderWeightages,
  normalizeWeightages,
  getWeightageSummary
} from "../../utils/weightageUtils";
import {
  setLocalSortingModelWeightages,
  getSortingModelWeightages,
  setSortingModelSelections,
  getSortingModelSelections,
  clearSortingModelData
} from "../../utils/localStorage";
import {
  CenterDescription,
  CenterTitle,
  CenterTitleWrapper,
  CenterWrapper,
  HorizontalLine,
  HospitalCardWrapper,
  NoKPISelectedDescription,
  NoKPISelectedWrapper,
  SingleWeightageWrapper,
  SliderContainer,
  WeightageContainer,
  WeightageInputContainer,
  IconWrapper,
  Popup,
  PopupHeader,
  PopupScrollWrapper,
  CenterPopup,
  RightPopup,
  CheckboxContainer,
  CheckboxLabel,
  HeaderSection,
  MainContainer,
  Reset,
  Title,
  TitleSection,
  FixedButtonContainer,
  Button,
  PaginationWrapper,
  TotalsText,
} from "./index.styled";
import Slider from "./Slider";
import { AnimatePresence, motion } from "framer-motion";
import { 
  createSortingModel, 
  setSortingModelWeightages, 
  setSortingModelVisibility,
  resetSortingModel,
  fetchSortingResults,
  loadMoreSortingResults
} from "../../Redux/sortingModel/sortingModel.actions";
import { triggerDataRefetch } from "../../Redux/app/app.actions";
import Loading from "../CustomTable/Loader"

const CATEGORY_MAP = {
  "Core Weightages": "CoreWeightages",
  "Facility Types": "Facility",
  "Ownership Types": "Ownership",
  "Financial & Operational Metrics": "Financial",
  "Oncology Focus - Procedure Volume (2023)": "Oncology",
  "Quality of care": "QualityOfCare",
  "Cancer Incidence": "CancerIncidence",
};

const SortingModelEnhanced = ({
  toggleState
}) => {
  const dispatch = useDispatch();
  const { isVisible: isSelectModelVisible } = useSelector((state) => state.sortingModel);
  const {
    isLoading,
    isFetching,
    isLoadingMore,
    error,
    isSuccess,
    weightages,
    rankings,
    totalHospitalsRanked,
    sampleRankings,
    page,
    totalPages,
    totalCount,
  } = useSelector((state) => state.sortingModel);
  // Hospital list in this modal is isolated from app filters (hex map, search,
  // advanced filters, global/partner chips). It always starts from /all and
  // only scopes when the local state dropdown below is changed.
  const [inputValue, setInputValue] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [ratings, setRatings] = useState({});
  const [percentageWeightages, setPercentageWeightages] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({
    CoreWeightages: [],
    Facility: [],
    Ownership: [],
    Financial: [],
    Oncology: [],
    QualityOfCare: [],
    CancerIncidence: [],
  });
  const [openIndexes, setOpenIndexes] = useState(data.map((_, index) => index));
  const [scrollStates, setScrollStates] = useState({});
  const [isDataRestored, setIsDataRestored] = useState(false);
  const scrollRaf = useRef({});
  const searchDebounceRef = useRef(null);
  const clearDebounceRef = useRef(null);

  // Load saved weightages and selections from localStorage on component mount
  useEffect(() => {
    const savedWeightages = getSortingModelWeightages();
    const savedSelections = getSortingModelSelections();
    
    if (savedWeightages && Object.keys(savedWeightages).length > 0) {
      setPercentageWeightages(savedWeightages);
      const sliderWeightages = percentageToSliderWeightages(savedWeightages);
      setRatings(sliderWeightages);
      setIsDataRestored(true);
    }
    
    if (savedSelections) {
      setSelectedOptions(savedSelections);
      setIsDataRestored(true);
    }
    
    // Show notification if data was restored
    // if ((savedWeightages && Object.keys(savedWeightages).length > 0) || savedSelections) {
    //   showSnackbar("Previous model settings restored from local storage", "info");
    // }
  }, []);

  // Reset selected state when model opens
  useEffect(() => {
    if (isSelectModelVisible) {
      setSelectedState("");
      setInputValue("");
      dispatch(
        fetchSortingResults({
          page: 1,
          perPage: 50,
        }),
      );
    }
  }, [isSelectModelVisible, dispatch]);



  const handleScroll = (e, id) => {
    if (scrollRaf.current[id]) {
      cancelAnimationFrame(scrollRaf.current[id]);
    }

    scrollRaf.current[id] = requestAnimationFrame(() => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 5;

      setScrollStates((prev) => {
        if (prev[id] === atBottom) return prev;
        return { ...prev, [id]: atBottom };
      });

      if (id === "right" && atBottom && !isLoadingMore && page < totalPages) {
        dispatch(
          loadMoreSortingResults({
            page: page + 1,
            perPage: 50,
            state: selectedState || undefined,
          }),
        );
      }
    });
  };

  const toggleAccordion = (index) => {
    setOpenIndexes((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const handleSliderChange = (label) => (value) => {
    setRatings((prev) => ({ ...prev, [label]: value }));
  };

  const handleWeightageChange = (newPercentageWeightages) => {
    setPercentageWeightages(newPercentageWeightages);
    
    // Convert percentage weightages back to slider ratings
    const newSliderWeightages = percentageToSliderWeightages(newPercentageWeightages);
    setRatings(newSliderWeightages);
  };

  const handleRemoveWeightage = (category, label) => {
    setSelectedOptions((prev) => {
      const updatedCategoryValues = prev[category].filter(
        (item) => item !== label,
      );
      const newSelectedOptions = {
        ...prev,
        [category]: updatedCategoryValues,
      };
      
      // Save selections to localStorage
      // setSortingModelSelections(newSelectedOptions);
      
      return newSelectedOptions;
    });

    setRatings((prev) => {
      const updatedRatings = { ...prev };
      delete updatedRatings[label];
      return updatedRatings;
    });

    setPercentageWeightages((prev) => {
      const updatedPercentages = { ...prev };
      delete updatedPercentages[label];
      return updatedPercentages;
    });
  };

  const isSelectionEmpty = Object.values(selectedOptions).every(
    (arr) => arr.length === 0,
  );

  const handleCheckboxChange = (category, label, checked) => {
    const categoryKey = CATEGORY_MAP[category];

    setSelectedOptions((prev) => {
      const currentCategoryValues = new Set(prev[categoryKey]);

      if (checked) {
        currentCategoryValues.add(label);
      } else {
        currentCategoryValues.delete(label);
      }

      const newSelectedOptions = {
        ...prev,
        [categoryKey]: Array.from(currentCategoryValues),
      };
      
      // Save selections to localStorage
      // setSortingModelSelections(newSelectedOptions);
      
      return newSelectedOptions;
    });

    // Initialize percentage weightages when new KPI is selected
    if (checked) {
      const allOptions = Object.entries(selectedOptions).flatMap(
        ([cat, values]) => values.map((lbl) => ({ category: cat, label: lbl })),
      );
      const newOption = { category: categoryKey, label };
      const allSelectedOptions = [...allOptions, newOption];
      
      if (allSelectedOptions.length > 0) {
        const equalPercentage = 100 / allSelectedOptions.length;
        const newPercentageWeightages = {};
        allSelectedOptions.forEach(({ label: lbl }) => {
          newPercentageWeightages[lbl] = equalPercentage;
        });
        setPercentageWeightages(newPercentageWeightages);
        
        // Also update slider ratings
        const newSliderWeightages = percentageToSliderWeightages(newPercentageWeightages);
        setRatings(newSliderWeightages);
      }
    } else {
              // Remove from percentage weightages when unchecked
        setPercentageWeightages((prev) => {
          const updated = { ...prev };
          delete updated[label];
          return updated;
        });
      
      // Also update slider ratings
      setRatings((prev) => {
        const updated = { ...prev };
        delete updated[label];
        return updated;
      });
    }
  };

  const handleInputChange = (name, value, isSelection = false) => {
    if (name === "state") {
      setInputValue(value);
      
      if (isSelection) {
        setSelectedState(value);
        dispatch(
          fetchSortingResults({
            page: 1,
            perPage: 50,
            state: value || undefined,
          }),
        );
      } else if (value === "" && isSelectModelVisible) {
        if (clearDebounceRef.current) {
          clearTimeout(clearDebounceRef.current);
        }
        clearDebounceRef.current = setTimeout(() => {
          setSelectedState("");
          dispatch(
            fetchSortingResults({
              page: 1,
              perPage: 50,
            }),
          );
        }, 1000);
      }
      return;
    }

    if (value === "") {
      handleSliderChange(name)("");
      return;
    }

    const numericValue = Number(value);
    if (!isNaN(numericValue)) {
      handleSliderChange(name)(value);
    } else {
      console.warn(`Invalid number for ${name}:`, value);
    }
  };

  const handleStartSimulation = async () => {
    // Save current state to localStorage before simulation
    setLocalSortingModelWeightages(percentageWeightages);
    setSortingModelSelections(selectedOptions);
    
    // Use percentage weightages for simulation
    const apiWeightages = {
      beds: percentageWeightages["Beds Count"] || 0,
      discharges: percentageWeightages["Discharges Count"] || 0,
      revenue: percentageWeightages["Net Patient Revenue"] || 0,
      rating: percentageWeightages["Overall Rating"] || 0
    };

    // Update Redux state with current weightages
    dispatch(setSortingModelWeightages(apiWeightages));

    // Call the API
    const result = await dispatch(createSortingModel(apiWeightages));
    
    if (result.success) {
      await dispatch(
        fetchSortingResults({
          page: 1,
          perPage: 50,
          state: selectedState || undefined,
        }),
      );
      console.log("Simulation completed successfully:", result.data);
    } else {
      console.error("Simulation failed:", result.error);
    }
  };

  const handleSaveModel = async () => {
    if (isSelectionEmpty) {
      return;
    }

    // Check if weightages are balanced
    const summary = getWeightageSummary(percentageWeightages);
    if (!summary.isBalanced) {
      return;
    }

    // Convert percentage weightages to API format
    const apiWeightages = {
      beds: percentageWeightages["Beds Count"] || 0,
      discharges: percentageWeightages["Discharges Count"] || 0,
      revenue: percentageWeightages["Net Patient Revenue"] || 0,
      rating: percentageWeightages["Overall Rating"] || 0
    };
    
    console.log("apiWeightages", apiWeightages, "percentageWeightages", percentageWeightages);

    // Save to localStorage
    setLocalSortingModelWeightages(percentageWeightages);
    setSortingModelSelections(selectedOptions);

    dispatch(setSortingModelWeightages(apiWeightages));
    const result = await dispatch(createSortingModel(apiWeightages));
    
    if (result.success) {
      setSelectedState("");
      setInputValue("");
      await dispatch(
        fetchSortingResults({
          page: 1,
          perPage: 50,
        }),
      );

      // Trigger data refetch for current view (Map or Table)
      dispatch(triggerDataRefetch());
    }
  };

  const handleStateSearch = () => {
    setSelectedState(inputValue);
    dispatch(
      fetchSortingResults({
        page: 1,
        perPage: 50,
        state: inputValue || undefined,
      }),
    );
  };


  const handleClosePopup = () => {
    dispatch(setSortingModelVisibility(false));
  };

  const handleCancel = () => {
    dispatch(resetSortingModel());
    // clearSortingModelData();
    handleClosePopup();
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleClosePopup();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      if (clearDebounceRef.current) {
        clearTimeout(clearDebounceRef.current);
      }
    };
  }, []);

  const allOptions = Object.entries(selectedOptions).flatMap(
    ([category, values]) => values.map((label) => ({ category, label })),
  );

  // Display rankings in the right panel if available
  const displayHospitals = rankings.length > 0 ? rankings : [];

  return (
    <>
      <BackgroundOverlay
        onClick={handleClosePopup}
        isPopupVisible={isSelectModelVisible}
      />
      <Popup isPopupVisible={isSelectModelVisible}>
        <PopupHeader>
          <TitleSection>
            <Title>Select Hospital KPIs</Title>
          </TitleSection>
          <Info
            showArrow={false}
            config={{
              tooltipText: "Close",
              position: "top",
            }}
          >
            <IconWrapper onClick={handleClosePopup}>
              <CompareCrossSolid />
            </IconWrapper>
          </Info>
        </PopupHeader>
        <PopupScrollWrapper 
          fullHeight
          onScroll={(e) => handleScroll(e, "popup")}
          isScrolledToBottom={scrollStates["popup"]}
        >
          {data.map((el, ind) => (
            <MainContainer key={ind}>
              <HeaderSection isFirst={ind === 0 || openIndexes.includes(ind-1)} onClick={() => toggleAccordion(ind)} open={openIndexes.includes(ind)}>
                {el.category}
                <Arrow/>
              </HeaderSection>
              <AnimatePresence initial={true}>
                {openIndexes.includes(ind) && (
                  <ContentWrapper
                    layout
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                  >
                    <RowContainer>
                      {el.fields.map((ele, ind) => (
                        <CheckboxContainer key={ind}>
                          <input
                            style={{
                              cursor: "pointer",
                              accentColor: "#F96250",
                              width: viewSizeCalculator(1.063),
                              height: viewSizeCalculator(1.063),
                            }}
                            type="checkbox"
                            id={ele.label}
                            onChange={(e) =>
                              handleCheckboxChange(
                                el.category,
                                ele.label,
                                e.target.checked,
                              )
                            }
                            checked={selectedOptions[
                              CATEGORY_MAP[el.category]
                            ].includes(ele.label)}
                          />
                          <CheckboxLabel htmlFor={ele.label}>
                            {ele.label}
                          </CheckboxLabel>
                        </CheckboxContainer>
                      ))}
                    </RowContainer>
                  </ContentWrapper>
                )}
              </AnimatePresence>
            </MainContainer>
          ))}
        </PopupScrollWrapper>

        <CenterPopup isSelectionEmpty={isSelectionEmpty}>
          <CenterWrapper>
            <CenterTitleWrapper>
              <NewSortModel />
                          <CenterTitle>
              {isSelectionEmpty ? "Score Builder" : isDataRestored ? "Restored Model" : "Untitled Model"}
            </CenterTitle>
            </CenterTitleWrapper>
            <CenterDescription>
              Assign a weight to each KPI by selecting a value between 1 and 10
            </CenterDescription>
          </CenterWrapper>
          {isSelectionEmpty && (
            <NoKPISelectedWrapper>
              <NoKPIsSelectedIcon />
              <NoKPISelectedDescription>
                Select KPIs from the left panel to begin setting up your score
                builder
              </NoKPISelectedDescription>
            </NoKPISelectedWrapper>
          )}
          {!isSelectionEmpty && (
            <>
              <WeightageSummaryContainer>
                <WeightageSummary>
                  <SummaryTitle>Weightage Distribution</SummaryTitle>
                  <SummaryContent>
                                         <SummaryItem>
                       <SummaryLabel>Total:</SummaryLabel>
                       <SummaryValue>
                         {getWeightageSummary(percentageWeightages).total.toFixed(2)}%
                       </SummaryValue>
                     </SummaryItem>
                    <SummaryItem>
                      <SummaryLabel>Active KPIs:</SummaryLabel>
                      <SummaryValue>
                        {getWeightageSummary(percentageWeightages).activeCount}
                      </SummaryValue>
                    </SummaryItem>
                    <SummaryItem>
                      <SummaryLabel>Status:</SummaryLabel>
                      <SummaryValue>
                        {getWeightageSummary(percentageWeightages).isBalanced ? (
                          <StatusSuccess>✓ Balanced</StatusSuccess>
                        ) : (
                          <StatusWarning>⚠ Needs Adjustment</StatusWarning>
                        )}
                      </SummaryValue>
                    </SummaryItem>
                  </SummaryContent>
                </WeightageSummary>
              </WeightageSummaryContainer>

              <PopupScrollWrapper>
                <AnimatePresence mode="popLayout">
                  {allOptions.map(({ category, label }, index) => (
                    <motion.div key={label}>
                      <WeightageContainer
                        layout
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.8 }}
                        transition={{
                          type: "spring",
                          stiffness: 300,
                          damping: 25,
                        }}
                      >
                        <SingleWeightageWrapper isLast={allOptions.length >= 5 && index === allOptions.length - 1}>
                          <WeightageInput
                            label={label}
                            sliderValue={ratings[label] ?? 5}
                            percentageValue={percentageWeightages[label] ?? 0}
                            onWeightageChange={handleWeightageChange}
                            totalWeightages={percentageWeightages}
                            currentKey={label}
                          />
                          <Info
                            showArrow={false}
                            config={{
                              tooltipText: "Remove Weightage",
                              position: "top",
                            }}
                          >
                            <DeleteWeightage
                              onClick={() =>
                                handleRemoveWeightage(category, label)
                              }
                            />
                          </Info>
                        </SingleWeightageWrapper>
                      </WeightageContainer>

                      {index !== allOptions.length - 1 && <HorizontalLine />}
                    </motion.div>
                  ))}
                </AnimatePresence>
              </PopupScrollWrapper>

              <FixedButtonContainer>
                <Button
                  color={"#3333333"}
                  backgroundColor={"#ffffff"}
                  borderColor={"#333333"}
                  onClick={handleCancel}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <Button
                  color={"#ffffff"}
                  backgroundColor={"#333333"}
                  borderColor={"#000000"}
                  onClick={handleSaveModel}
                  disabled={isLoading || !getWeightageSummary(percentageWeightages).isBalanced}
                >
                  {isLoading ? "Saving..." : "Save"}
                </Button>
              </FixedButtonContainer>
            </>
          )}
        </CenterPopup>

        <RightPopup>
          <PopupHeader>
            <TitleSection>
              <Title>Simulator</Title>
            </TitleSection>
            <PaginationAndTotals stateFilter={inputValue} />
          </PopupHeader>
          <CustomInput
            placeholder={"Choose a state to begin the simulation"}
            dropdown={true}
            comboMode={true}
            label={"State"}
            name="state"
            value={
              inputValue
                ? states[inputValue] !== undefined
                  ? `${states[inputValue]} (${inputValue})`
                  : inputValue
                : ""
            }
            onChange={handleInputChange}
            suggestions={stateList}
            suggestionLoader={false}
            onNoMatch={() => {}}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleStateSearch();
              }
            }}
          />
          <PopupScrollWrapper
            fullHeight
            onScroll={(e) => handleScroll(e, "right")}
            isScrolledToBottom={scrollStates["right"]}
          >
            <HospitalCardWrapper>
              {isFetching && rankings.length === 0 ? (
                <LoaderContainer>
                  <Loading config={{ top: "0%" }} />
                </LoaderContainer>
              ) : (
                displayHospitals?.map((ele, i) => (
                  <HospitalListCard
                    data={ele}
                    key={i}
                    sortingLabel={"Ranking"}
                    toggleState={toggleState}
                  />
                ))
              )}
              {isLoadingMore && (
                <LoadMoreContainer>
                  <Loading config={{ top: "0%" }} />
                </LoadMoreContainer>
              )}
            </HospitalCardWrapper>
          </PopupScrollWrapper>
        </RightPopup>
       </Popup>
     </>
   );
 };

export default SortingModelEnhanced;

// Pagination and Totals sub-component for Simulator
const PaginationAndTotals = ({ stateFilter }) => {
  const { totalCount, count, rankings } = useSelector((state) => state.sortingModel);

  if (totalCount === 0) return null;

  const startIndex = rankings.length > 0 ? 1 : 0;
  const endIndex = rankings.length;

  return (
    <PaginationWrapper>
      <TotalsText>
        {startIndex}-{endIndex} of {totalCount}
      </TotalsText>
    </PaginationWrapper>
  );
};

const ContentWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  flex-wrap: ${({ wrap }) => (wrap ? "wrap" : "no-wrap")};
  gap: ${() => `${viewSizeCalculator(0.75)}`};
  width: 100%;
`;

const WeightageSummaryContainer = styled.div`
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
`;

const WeightageSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SummaryTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
`;

const SummaryContent = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SummaryLabel = styled.span`
  font-size: 14px;
  color: #666;
  font-weight: 500;
`;

const SummaryValue = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

const StatusSuccess = styled.span`
  color: #28a745;
  font-weight: 600;
`;

const StatusWarning = styled.span`
  color: #ffc107;
  font-weight: 600;
`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
`;

const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${() => `${viewSizeCalculator(3.75)}`};
  flex-shrink: 0;
`;